import script from "./KanjiView.vue?vue&type=script&setup=true&lang=js"
export * from "./KanjiView.vue?vue&type=script&setup=true&lang=js"

import "./KanjiView.vue?vue&type=style&index=0&id=664cd2e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-664cd2e8"]])

export default __exports__